
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index5y38Q_45LvVzd5L1AMKTFuSZlh4rB9m07JgzDS7vcUFDsMeta } from "/home/runner/work/seed/seed/pages/index.vue?macro=true";
import { default as visitGHpAK2qY3URqbO5EgoFG1_45vUD4ocFJNJlSEPyL8ov6oMeta } from "/home/runner/work/seed/seed/pages/visit.vue?macro=true";
import { default as searchroqlRmojgYOG4wjP_FXxDuaqNJOPyPWzKyk76iy1RLwMeta } from "/home/runner/work/seed/seed/pages/search.vue?macro=true";
import { default as contactkmAh6AHqn_GH8CjoCUHQHYPO115wUsBuU7ManJVw_fEMeta } from "/home/runner/work/seed/seed/pages/contact.vue?macro=true";
import { default as supportT7dMgNaxvkoS_45ylBD3pFCrUyknBosAl_45fQwJycntarUMeta } from "/home/runner/work/seed/seed/pages/support.vue?macro=true";
import { default as _91_46_46_46all_93vEtlLHkgkrGRRduVKvHBVUyIK3yg6TYVERxxVwYh2pIMeta } from "/home/runner/work/seed/seed/pages/[...all].vue?macro=true";
import { default as pressroomt6HwTPGKljaQbJDtXfa_45fL9VvcEuuPL_hPTlcZ6t_45j4Meta } from "/home/runner/work/seed/seed/pages/pressroom.vue?macro=true";
import { default as visionc3tJpmYyUwFnnm6eEDslffJrJedcczUZ8e8pU5twMyQMeta } from "/home/runner/work/seed/seed/pages/about/vision.vue?macro=true";
import { default as indexTBa0EweiVpti8ahUNBQSYp6dsyo17_r1mCIxFU0ilrAMeta } from "/home/runner/work/seed/seed/pages/people/index.vue?macro=true";
import { default as networkvqKhnuJXg64WH935DzTfdsgdQIdtRfRhGSzF45c_ClIMeta } from "/home/runner/work/seed/seed/pages/about/network.vue?macro=true";
import { default as _91slug_93n7_45_IA1KpEg7wrZIX9s78TfLBqLWse9E_456V2NrqqakQMeta } from "/home/runner/work/seed/seed/pages/people/[slug].vue?macro=true";
import { default as privacy_policyK9z1nkvVKoEMXE2Z_45RinpdvzP8R4WSkcHG_ooln5ftgMeta } from "/home/runner/work/seed/seed/pages/privacy_policy.vue?macro=true";
import { default as institutehUefC6AzHFrWH9jiBz86VXCwqaTD5qVAg4GsNNDxDGIMeta } from "/home/runner/work/seed/seed/pages/about/institute.vue?macro=true";
import { default as terms_of_service_wJpYjg_45gTSBPwg_EV5h3kuihNO0XWU2wJ_456o7IxpoQMeta } from "/home/runner/work/seed/seed/pages/terms_of_service.vue?macro=true";
import { default as indexMvbROQkZj9qt1W5gnn6e596WX38yPZdJRXDX_45rmwGpIMeta } from "/home/runner/work/seed/seed/pages/activities/news/index.vue?macro=true";
import { default as _91slug_937OI9z_tT4G067nDHSChrCRJTa7NtJnjZxhvIkziMkMUMeta } from "/home/runner/work/seed/seed/pages/activities/news/[slug].vue?macro=true";
import { default as index2BUMgwmcqmtxEP8UUy5tpVtShZpIkktvNbWj_45_S42K8Meta } from "/home/runner/work/seed/seed/pages/activities/events/index.vue?macro=true";
import { default as _91slug_93gXRB9hto6yedIxyeMkCJ2sc_HQxvOkD5rviHRdf3Z4wMeta } from "/home/runner/work/seed/seed/pages/activities/events/[slug].vue?macro=true";
import { default as indexj4rqZC5sDQmtkG1cmz1ASh2ADVSkAL3aUV7hy7rilYsMeta } from "/home/runner/work/seed/seed/pages/activities/projects/index.vue?macro=true";
import { default as _91slug_93tDBrmJ5cABbK8_45sqB_45T0ndaL03EtN_9fe5sJpHQPrecMeta } from "/home/runner/work/seed/seed/pages/activities/projects/[slug].vue?macro=true";
import { default as helpHzvSz4zj4ImmnH3xNVIysM46Mdcwi_lrjDHQRRQljaMMeta } from "/home/runner/work/seed/seed/pages/activities/memberships/help.vue?macro=true";
import { default as indexdnCsBpGt_453NUugipYX3jVub3rvFd8EVA_nXHChqkDEwMeta } from "/home/runner/work/seed/seed/pages/activities/fellowships/index.vue?macro=true";
import { default as indexJmsfAGAAWaJZey8zcEsuDt34t_453kZbD1hkWmeMpfCLYMeta } from "/home/runner/work/seed/seed/pages/activities/memberships/index.vue?macro=true";
import { default as _91slug_93MfmS6EhRocvvm18eItty3_45KDsgVCBOrL0_Nwczv4yCgMeta } from "/home/runner/work/seed/seed/pages/activities/fellowships/[slug].vue?macro=true";
import { default as index2UuARyy2pS2NlNi5BiUs13Iy2k_45dfSesCqtiToYZV4YMeta } from "/home/runner/work/seed/seed/pages/activities/publications/index.vue?macro=true";
import { default as hostingJN0_Qsp5DxWL_Jd9dx7iVbYEhWrPjvdUjfsP0cYvfmcMeta } from "/home/runner/work/seed/seed/pages/activities/memberships/hosting.vue?macro=true";
import { default as _91slug_93xSVXJBx6VAH9DeomfJNC_vhd6NV_YyWqK4FF0_45dSNBMMeta } from "/home/runner/work/seed/seed/pages/activities/publications/[slug].vue?macro=true";
import { default as component_45stubC811fVQv_454BZqhpgrUImsvm0M_45ewzggCNl1JleReDR0Meta } from "/home/runner/work/seed/seed/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubC811fVQv_454BZqhpgrUImsvm0M_45ewzggCNl1JleReDR0 } from "/home/runner/work/seed/seed/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___fr",
    path: "/fr",
    meta: index5y38Q_45LvVzd5L1AMKTFuSZlh4rB9m07JgzDS7vcUFDsMeta || {},
    component: () => import("/home/runner/work/seed/seed/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: index5y38Q_45LvVzd5L1AMKTFuSZlh4rB9m07JgzDS7vcUFDsMeta || {},
    component: () => import("/home/runner/work/seed/seed/pages/index.vue")
  },
  {
    name: "visit___fr",
    path: "/fr/visit",
    component: () => import("/home/runner/work/seed/seed/pages/visit.vue")
  },
  {
    name: "visit___en",
    path: "/visit",
    component: () => import("/home/runner/work/seed/seed/pages/visit.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    component: () => import("/home/runner/work/seed/seed/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/search",
    component: () => import("/home/runner/work/seed/seed/pages/search.vue")
  },
  {
    name: "contact___fr",
    path: "/fr/contact",
    component: () => import("/home/runner/work/seed/seed/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/contact",
    component: () => import("/home/runner/work/seed/seed/pages/contact.vue")
  },
  {
    name: "support___fr",
    path: "/fr/support",
    component: () => import("/home/runner/work/seed/seed/pages/support.vue")
  },
  {
    name: "support___en",
    path: "/support",
    component: () => import("/home/runner/work/seed/seed/pages/support.vue")
  },
  {
    name: "all___fr",
    path: "/fr/:all(.*)*",
    meta: _91_46_46_46all_93vEtlLHkgkrGRRduVKvHBVUyIK3yg6TYVERxxVwYh2pIMeta || {},
    component: () => import("/home/runner/work/seed/seed/pages/[...all].vue")
  },
  {
    name: "all___en",
    path: "/:all(.*)*",
    meta: _91_46_46_46all_93vEtlLHkgkrGRRduVKvHBVUyIK3yg6TYVERxxVwYh2pIMeta || {},
    component: () => import("/home/runner/work/seed/seed/pages/[...all].vue")
  },
  {
    name: "pressroom___fr",
    path: "/fr/pressroom",
    component: () => import("/home/runner/work/seed/seed/pages/pressroom.vue")
  },
  {
    name: "pressroom___en",
    path: "/pressroom",
    component: () => import("/home/runner/work/seed/seed/pages/pressroom.vue")
  },
  {
    name: "about-vision___fr",
    path: "/fr/about/vision",
    meta: visionc3tJpmYyUwFnnm6eEDslffJrJedcczUZ8e8pU5twMyQMeta || {},
    component: () => import("/home/runner/work/seed/seed/pages/about/vision.vue")
  },
  {
    name: "about-vision___en",
    path: "/about/vision",
    meta: visionc3tJpmYyUwFnnm6eEDslffJrJedcczUZ8e8pU5twMyQMeta || {},
    component: () => import("/home/runner/work/seed/seed/pages/about/vision.vue")
  },
  {
    name: "people___fr",
    path: "/fr/people",
    component: () => import("/home/runner/work/seed/seed/pages/people/index.vue")
  },
  {
    name: "people___en",
    path: "/people",
    component: () => import("/home/runner/work/seed/seed/pages/people/index.vue")
  },
  {
    name: "about-network___fr",
    path: "/fr/about/network",
    meta: networkvqKhnuJXg64WH935DzTfdsgdQIdtRfRhGSzF45c_ClIMeta || {},
    component: () => import("/home/runner/work/seed/seed/pages/about/network.vue")
  },
  {
    name: "about-network___en",
    path: "/about/network",
    meta: networkvqKhnuJXg64WH935DzTfdsgdQIdtRfRhGSzF45c_ClIMeta || {},
    component: () => import("/home/runner/work/seed/seed/pages/about/network.vue")
  },
  {
    name: "people-slug___fr",
    path: "/fr/people/:slug()",
    component: () => import("/home/runner/work/seed/seed/pages/people/[slug].vue")
  },
  {
    name: "people-slug___en",
    path: "/people/:slug()",
    component: () => import("/home/runner/work/seed/seed/pages/people/[slug].vue")
  },
  {
    name: "privacy_policy___fr",
    path: "/fr/privacy_policy",
    component: () => import("/home/runner/work/seed/seed/pages/privacy_policy.vue")
  },
  {
    name: "privacy_policy___en",
    path: "/privacy_policy",
    component: () => import("/home/runner/work/seed/seed/pages/privacy_policy.vue")
  },
  {
    name: "about-institute___fr",
    path: "/fr/about/institute",
    meta: institutehUefC6AzHFrWH9jiBz86VXCwqaTD5qVAg4GsNNDxDGIMeta || {},
    component: () => import("/home/runner/work/seed/seed/pages/about/institute.vue")
  },
  {
    name: "about-institute___en",
    path: "/about/institute",
    meta: institutehUefC6AzHFrWH9jiBz86VXCwqaTD5qVAg4GsNNDxDGIMeta || {},
    component: () => import("/home/runner/work/seed/seed/pages/about/institute.vue")
  },
  {
    name: "terms_of_service___fr",
    path: "/fr/terms_of_service",
    component: () => import("/home/runner/work/seed/seed/pages/terms_of_service.vue")
  },
  {
    name: "terms_of_service___en",
    path: "/terms_of_service",
    component: () => import("/home/runner/work/seed/seed/pages/terms_of_service.vue")
  },
  {
    name: "activities-news___fr",
    path: "/fr/activities/news",
    component: () => import("/home/runner/work/seed/seed/pages/activities/news/index.vue")
  },
  {
    name: "activities-news___en",
    path: "/activities/news",
    component: () => import("/home/runner/work/seed/seed/pages/activities/news/index.vue")
  },
  {
    name: "activities-news-slug___fr",
    path: "/fr/activities/news/:slug()",
    component: () => import("/home/runner/work/seed/seed/pages/activities/news/[slug].vue")
  },
  {
    name: "activities-news-slug___en",
    path: "/activities/news/:slug()",
    component: () => import("/home/runner/work/seed/seed/pages/activities/news/[slug].vue")
  },
  {
    name: "activities-events___fr",
    path: "/fr/activities/events",
    component: () => import("/home/runner/work/seed/seed/pages/activities/events/index.vue")
  },
  {
    name: "activities-events___en",
    path: "/activities/events",
    component: () => import("/home/runner/work/seed/seed/pages/activities/events/index.vue")
  },
  {
    name: "activities-events-slug___fr",
    path: "/fr/activities/events/:slug()",
    component: () => import("/home/runner/work/seed/seed/pages/activities/events/[slug].vue")
  },
  {
    name: "activities-events-slug___en",
    path: "/activities/events/:slug()",
    component: () => import("/home/runner/work/seed/seed/pages/activities/events/[slug].vue")
  },
  {
    name: "activities-projects___fr",
    path: "/fr/activities/projects",
    component: () => import("/home/runner/work/seed/seed/pages/activities/projects/index.vue")
  },
  {
    name: "activities-projects___en",
    path: "/activities/projects",
    component: () => import("/home/runner/work/seed/seed/pages/activities/projects/index.vue")
  },
  {
    name: "activities-projects-slug___fr",
    path: "/fr/activities/projects/:slug()",
    component: () => import("/home/runner/work/seed/seed/pages/activities/projects/[slug].vue")
  },
  {
    name: "activities-projects-slug___en",
    path: "/activities/projects/:slug()",
    component: () => import("/home/runner/work/seed/seed/pages/activities/projects/[slug].vue")
  },
  {
    name: "activities-memberships-help___fr",
    path: "/fr/activities/memberships/help",
    component: () => import("/home/runner/work/seed/seed/pages/activities/memberships/help.vue")
  },
  {
    name: "activities-memberships-help___en",
    path: "/activities/memberships/help",
    component: () => import("/home/runner/work/seed/seed/pages/activities/memberships/help.vue")
  },
  {
    name: "activities-fellowships___fr",
    path: "/fr/activities/fellowships",
    component: () => import("/home/runner/work/seed/seed/pages/activities/fellowships/index.vue")
  },
  {
    name: "activities-fellowships___en",
    path: "/activities/fellowships",
    component: () => import("/home/runner/work/seed/seed/pages/activities/fellowships/index.vue")
  },
  {
    name: "activities-memberships___fr",
    path: "/fr/activities/memberships",
    component: () => import("/home/runner/work/seed/seed/pages/activities/memberships/index.vue")
  },
  {
    name: "activities-memberships___en",
    path: "/activities/memberships",
    component: () => import("/home/runner/work/seed/seed/pages/activities/memberships/index.vue")
  },
  {
    name: "activities-fellowships-slug___fr",
    path: "/fr/activities/fellowships/:slug()",
    component: () => import("/home/runner/work/seed/seed/pages/activities/fellowships/[slug].vue")
  },
  {
    name: "activities-fellowships-slug___en",
    path: "/activities/fellowships/:slug()",
    component: () => import("/home/runner/work/seed/seed/pages/activities/fellowships/[slug].vue")
  },
  {
    name: "activities-publications___fr",
    path: "/fr/activities/publications",
    component: () => import("/home/runner/work/seed/seed/pages/activities/publications/index.vue")
  },
  {
    name: "activities-publications___en",
    path: "/activities/publications",
    component: () => import("/home/runner/work/seed/seed/pages/activities/publications/index.vue")
  },
  {
    name: "activities-memberships-hosting___fr",
    path: "/fr/activities/memberships/hosting",
    component: () => import("/home/runner/work/seed/seed/pages/activities/memberships/hosting.vue")
  },
  {
    name: "activities-memberships-hosting___en",
    path: "/activities/memberships/hosting",
    component: () => import("/home/runner/work/seed/seed/pages/activities/memberships/hosting.vue")
  },
  {
    name: "activities-publications-slug___fr",
    path: "/fr/activities/publications/:slug()",
    component: () => import("/home/runner/work/seed/seed/pages/activities/publications/[slug].vue")
  },
  {
    name: "activities-publications-slug___en",
    path: "/activities/publications/:slug()",
    component: () => import("/home/runner/work/seed/seed/pages/activities/publications/[slug].vue")
  },
  {
    name: component_45stubC811fVQv_454BZqhpgrUImsvm0M_45ewzggCNl1JleReDR0Meta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubC811fVQv_454BZqhpgrUImsvm0M_45ewzggCNl1JleReDR0
  },
  {
    name: component_45stubC811fVQv_454BZqhpgrUImsvm0M_45ewzggCNl1JleReDR0Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubC811fVQv_454BZqhpgrUImsvm0M_45ewzggCNl1JleReDR0
  }
]